import { Check } from "@mui/icons-material";
import { Box, Step, StepConnector, stepConnectorClasses, StepLabel, Stepper, styled, Typography } from "@mui/material";

const WizardStepConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#AF3241',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#AF3241',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: '#eaeaf0',
        borderTopWidth: 3,
        borderRadius: 1,
        ...theme.applyStyles('dark', {
            borderColor: theme.palette.grey[800],
        }),
    },
}));

const WizardStepIconRoot = styled('div')(({ theme }) => ({
    color: '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
    '& .QontoStepIcon-completedIcon': {
        color: '#AF3241',
        zIndex: 1,
        fontSize: 18,
    },
    '& .QontoStepIcon-circle': {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
    },
    ...theme.applyStyles('dark', {
        color: theme.palette.grey[700],
    }),
    variants: [
        {
            props: ({ ownerState }) => ownerState.active,
            style: {
                color: '#AF3241',
            },
        },
    ],
}));

function WizardStepIcon(props) {
    const { active, completed, className } = props;

    return (
        <WizardStepIconRoot ownerState={{ active }} className={className}>
            {completed ? (
                <Check className="QontoStepIcon-completedIcon" />
            ) : (
                <div className="QontoStepIcon-circle" />
            )}
        </WizardStepIconRoot>
    );
}


const WizardStepper = ({ activeStep, stepLabels, onStepClick }) => {
    return (
        <Stepper sx={{ width: '100%' }} activeStep={activeStep} alternativeLabel connector={<WizardStepConnector />}>
            {
                stepLabels.map((label, index) => (
                    <Step key={index + "_wizardStepper"} >
                        <StepLabel
                            StepIconComponent={WizardStepIcon}
                            sx={{
                                cursor: 'default',
                                '& .MuiStepLabel-label': {
                                    cursor: 'default',
                                    pointerEvents: 'none',
                                },
                                '& .MuiStepIcon-root': {
                                    cursor: 'default',
                                },
                            }}
                        >
                            <strong>{label}</strong>
                        </StepLabel>
                    </Step>
                ))
            }
        </Stepper>
    );
};

export default WizardStepper;
